const PaymentTerms = () => import("Core/configuration/payment_terms/views/PaymentTerms");
const PaymentTermsForm = () => import("Core/configuration/payment_terms/views/PaymentTermsForm");

export default {
    children: [
        {
            path: "payment_terms",
            name: "payment_terms",
            component: PaymentTerms,
            meta: {
                requiresAuth: true,
                title: "lang.payment_terms",
                restrict_by_login_type: [
                    "employee",
                    "customer_support",
                    "administrator",
                    "developer",
                    "csr",
                    "producer",
                    "dispatcher",
                    "technician",
                    "driver",
                    "dispenser_mgr",
                    "customer_readonly",
                    "customer",
                ],
                restrict_by_permission: ["configuration.read"],
            },
        },
        {
            path: "payment_term/:id?",
            name: "payment_term",
            component: PaymentTermsForm,
            meta: {
                requiresAuth: true,
                title: "lang.payment_terms",
                restrict_by_login_type: [
                    "employee",
                    "customer_support",
                    "administrator",
                    "developer",
                    "csr",
                    "producer",
                    "dispatcher",
                    "technician",
                    "driver",
                    "dispenser_mgr",
                    "customer_readonly",
                    "customer",
                ],
                restrict_by_permission: ["configuration.read"],
            },
        },
    ],
};
